import React, { useState } from "react";
import { CmpSplashprogress } from "../../components/CmpSplashprogress";
import "./style.css";

export const CcSplash = ({ progress = 0 }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageError = () => {
    console.warn('Coach Cedar SVG failed to load, showing fallback text');
    setImageError(true);
  };

  const handleImageLoad = () => {
    console.log('Coach Cedar SVG loaded successfully');
    setImageLoaded(true);
  };

  return (
    <div className="CC-splash" data-model-id="2288:5427">
      <div className="overlap-group-wrapper">
        <div className="overlap-group">
          <CmpSplashprogress
            className="cmp-splashprogress-instance"
            status="loading"
            progress={progress}
          />
          {!imageError ? (
            <img 
              className="coach-cedar" 
              alt="Coach Cedar" 
              /* Use the app icon to avoid duplicate "Coach Cedar" wordmark/title */
              src="/favicon.png"
              onError={handleImageError}
              onLoad={handleImageLoad}
              style={{
                opacity: imageLoaded ? 1 : 0.7,
                transition: 'opacity 0.3s ease-in-out'
              }}
            />
          ) : (
            <div 
              className="coach-cedar coach-cedar-fallback"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                /* No text fallback — keep the loading screen clean */
                color: 'transparent'
              }}
            >
              .
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
